import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
// On www vs bare-domain mismatch, call the API on the host the shopper is on (same-origin, no CORS issues).
const sameSite = (a, b) => a.replace(/^www\./, "") === b.replace(/^www\./, "");
export const BACKEND_ORIGIN = sameSite(new URL(BACKEND).hostname, window.location.hostname) ? window.location.origin : BACKEND;
export const API = `${BACKEND_ORIGIN}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh"];

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("wt_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && orig && !orig._retry && !NO_REFRESH.some((u) => orig.url.includes(u))) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const { data } = await refreshing;
        refreshing = null;
        localStorage.setItem("wt_token", data.access_token);
        return api(orig);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem("wt_token");
      }
    }
    return Promise.reject(err);
  }
);

export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const DISCLAIMER =
  "For education & investigative use only. Wave Therapy is a health & wellness device — not intended to diagnose, treat, cure or prevent any disease.";
